import { HeaderRectV2, HeaderTextV2 } from '@/components/public/Visualisations/BubblesV2/Entities'
import { HeaderMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Shapes } from '@/components/public/Visualisations/types'
import typedStore from '@/store/typedStore'
import { PopupDetails, VisNode } from '@/types'
import Konva from 'konva'

export class HeaderGroupV2 extends Konva.Group implements Shapes.Group, Shapes.HasPopup {
  private _metadata: HeaderMetadata
  private _text: HeaderTextV2
  private _rect: HeaderRectV2
  private _popupDetails?: PopupDetails
  capabilities: Shapes.Capability[] = [Shapes.Capability.Fadable, Shapes.Capability.Popup]
  entities: Shapes.Entity[] = []

  constructor(metadata: HeaderMetadata) {
    super()

    this._text = new HeaderTextV2(metadata)
    this._rect = new HeaderRectV2(metadata)
    this.addShape(this._rect)
    this.addShape(this._text)

    metadata.onPositionChanged((position) => {
      this.position(position)
    })

    this._metadata = metadata
    this.refresh()
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get left() {
    return this.x() - this._rect.width() / 2
  }

  get top() {
    return this.y() - this._rect.height() / 2
  }

  get center() {
    return this.position()
  }

  get popupDetails(): PopupDetails {
    if (!this._popupDetails) {
      const treeNode = typedStore.visualisationData.filteredTreeRoot.search(this.path)
      if (treeNode) {
        this._popupDetails = {
          node: typedStore.visualisationData.buildVisNode(treeNode),
          leftBuffer: 10,
        }
      } else {
        this._popupDetails = {
          node: undefined as unknown as VisNode,
        }
      }
    }

    return this._popupDetails
  }

  refresh() {
    this._text.refresh()
    this._rect.refresh()
  }

  private addShape(shape: Shapes.Shape) {
    this.entities.push(shape)
    this.add(shape)
  }
}
